import React, { useCallback } from 'react';
import { Button } from '../ui/button';
import { cn } from 'lib/utils';
import { useDebug } from 'contexts/DebugContext';

type DebugToggleProps = {
  className?: string;
};

export const DebugToggle: React.FC<DebugToggleProps> = ({ className }) => {
  const { isEnabled, isForced, isUpdating, canToggle, isAdmin, toggle } = useDebug();

  const handleClick = useCallback(() => {
    if (!canToggle) {
      return;
    }
    void toggle().catch((error) => {
      console.error('DebugToggle: failed to update debug mode', error);
    });
  }, [canToggle, toggle]);

  const shouldRender = isAdmin || isEnabled || isForced;
  if (!shouldRender) {
    return null;
  }

  const label = isForced ? 'Debug forced' : isEnabled ? 'Debug on' : 'Debug off';

  return (
    <Button
      type="button"
      size="auto"
      variant={isEnabled ? 'default' : 'secondary'}
      disabled={!canToggle || isUpdating}
      onClick={handleClick}
      className={cn(
        'h-7 rounded-full px-3 text-xs font-medium shadow-none hover:shadow-none',
        className,
      )}
    >
      {isUpdating ? 'Updating...' : label}
    </Button>
  );
};
